import axios from 'axios';
import { createHeaders, withReThrowingDataServiceError, } from './data-service-api';
export class DataServiceWalletsApiClientV0 {
    constructor(baseUrl, tokenProvider) {
        this.baseUrl = baseUrl;
        this.tokenProvider = tokenProvider;
    }
    async createDappAddress(command, dapp) {
        const token = await this.tokenProvider.get();
        const headers = createHeaders(token);
        return withReThrowingDataServiceError(axios
            .post(`${this.baseUrl}/v0/wallets/${token.body.sub}/dapps/${dapp}/addresses`, command, {
            headers: headers,
        })
            .then((it) => it.data));
    }
    async deleteDappAddress(command) {
        const token = await this.tokenProvider.get();
        return withReThrowingDataServiceError(axios
            .delete(`${this.baseUrl}/v0/wallets/${token.body.sub}/addresses/${command.id}`, {
            headers: createHeaders(token),
        })
            .then((it) => it.data));
    }
    async findAllDappAddresses(dapp) {
        const token = await this.tokenProvider.get();
        return withReThrowingDataServiceError(axios
            .get(`${this.baseUrl}/v0/wallets/${token.body.sub}/dapps/${dapp}/addresses`, {
            headers: createHeaders(token),
        })
            .then((it) => it.data));
    }
}
//# sourceMappingURL=data-service-wallets-api.v0.js.map